import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { TiCancelOutline } from "react-icons/ti";
import CancelOrderDialogue from './cancelOrderDialogueComponent.jsx';





export default function CancelledOrdersDataTable(props) {

  const loadAllSales = () => {
    props.loadSales()
  }
  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'orderid', headerName: 'orderID', width: 100 },

    { field: 'subscriberID', headerName: 'Subscriber ID', width: 200 },

    {
      field: 'ordertype',
      headerName: 'Order Type',
      type: 'string',
      width: 200,
    },
    {
      field: 'total',
      headerName: 'Total Amount(GHC)',
      type: 'string',
      width: 200,
    },
    {
      field: 'date',
      headerName: 'Date & Time',
      type: 'string',
      width: 200,
    },

  ];

  const rows = [
  ];
  props.tableData.map(
    (item, index) => {
      const rowItem = { id: index, orderid: item.id, subscriberID: item.card_code, ordertype: item.payment_method, total: item.total_amount.toFixed(2), date: item.deleted_at }
      rows.push(rowItem)
    }
  )
  return (
    <div style={{ height: 400, width: '95%', backgroundColor: "white" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
      // checkboxSelection
      />
    </div>
  );
}
